import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { decode } from "js-base64";
import Collapse from "../BP2Components/Collapse";
import IntlMessages from "@util/IntlMessages";
import sanitizeHtml from "sanitize-html";
import "./commentsItem.less";
import { Icon_Flag } from "../BP2Components/Icons/icons";
import { Avatar, Comment } from "../BP2Components";

const CommentsItem = ({ comment, scrollToFieldByTechname }) => {
   const { listOfAllUsers } = useSelector(({ messages }) => messages);
   const { avatars } = useSelector(({ companies }) => companies);
   const avatar = avatars?.find(({ userOldId }) => userOldId === comment?.user_id)?.avatarUrl;
   const author = listOfAllUsers?.find(({ oldId }) => oldId == comment?.user_id);
   const recipient = listOfAllUsers?.find(({ oldId }) => oldId == comment?.assigned_user_id_to);
   const [isImageOpen, setIsImageOpen] = useState(false);
   const [imageSrc, setImageSrc] = useState("");
   const isCommentWithSysData = (htmlText) => {
      return htmlText && typeof htmlText === "string" && htmlText?.includes("_sysdata_");
   };

   const getCommentWithoutSystemData = (htmlText) => {
      if (htmlText && typeof htmlText === "string" && htmlText?.includes("_sysdata_</span>")) {
         htmlText = htmlText.split("_sysdata_</span>")[1];
      }
      return htmlText;
   };

   const getCommentSystemData = (htmlText) => {
      let systemCommentDataList = [];
      if (htmlText && typeof htmlText === "string" && htmlText?.includes("_sysdata_")) {
         htmlText = htmlText.split("_sysdata_")[1];
         try {
            const decodedData = decode(htmlText);
            if (typeof decodedData === "string") {
               const parsedData = JSON.parse(decodedData);
               Object.keys(parsedData).forEach((key) => {
                  systemCommentDataList.push(parsedData[key]);
               });
            }
         } catch {
            console.log("error decoding comment system data");
         }
      }
      return systemCommentDataList;
   };

   const openImage = (target) => {
      if (target.tagName === "IMG") {
         setImageSrc(target?.src);
         setIsImageOpen(true);
      }
   };

   const closeImage = () => {
      setIsImageOpen(false);
   };

   useEffect(() => {
      const handleKeyDown = () => {
         if (event.key === "Escape") {
            closeImage();
         }
      };

      window.addEventListener("keydown", handleKeyDown);

      return () => {
         window.removeEventListener("keydown", handleKeyDown);
      };
   }, []);

   const commentData = getCommentSystemData(comment?.comment);
   return (
      <>
         <div className="step-changelog-info gx-pt-2 p3">{comment?.step_performed}</div>
         {isCommentWithSysData(comment?.comment) ? (
            /* SYSTEM COMMENT */
            <Comment
               className="comment-system-item"
               content={
                  <div className="system-comment-data">
                     <div className="system-comment-header gx-pb-2">
                        <Icon_Flag></Icon_Flag>
                        <span className="gx-pt-2">
                           <b>{author ? `${author.firstName} ${author.lastName}` : ""}</b>
                           <span className="system-comment-date">{` - ${comment.created}`}</span>
                        </span>
                     </div>
                     {commentData.length > 1 ? (
                        <Collapse
                           header={
                              <div className="gx-pb-1">
                                 <span className="gx-pr-1">
                                    <b>{`${commentData[0]?.label}: `}</b>
                                 </span>
                                 {typeof commentData[0]?.value === "string" &&
                                 commentData[0]?.value?.includes("_anchor_") ? (
                                    <span
                                       className={`comment-anchor`}
                                       id={`anchor-${commentData[0]?.value.replaceAll(
                                          "_anchor_",
                                          "",
                                       )}`}
                                       onClick={() =>
                                          scrollToFieldByTechname?.(
                                             commentData[0]?.value.split("_anchor_")[1],
                                          )
                                       }
                                    >
                                       <IntlMessages id="comments.show" /> {" ->"}
                                    </span>
                                 ) : (
                                    <>
                                       {commentData[0]?.label !== "New File" &&
                                       commentData[0]?.label !== "Remove File" ? (
                                          <>
                                             <span
                                                style={{ textDecoration: "line-through" }}
                                             >{`${commentData[0]?.initial}`}</span>
                                             <span>
                                                <b>{` -> `}</b>
                                             </span>
                                          </>
                                       ) : null}
                                       <span>{`${commentData[0]?.value}`}</span>
                                    </>
                                 )}
                                 <div className="system-comment-show-more gx-pt-1 gx-pb-1">
                                    <b>
                                       ...
                                       <IntlMessages id="comments.showMore" />
                                    </b>
                                 </div>
                              </div>
                           }
                           openHeader={
                              <div className="system-comment-show-more gx-pt-1 gx-pb-1">
                                 <b>
                                    <IntlMessages id="comments.showLess" />
                                 </b>
                              </div>
                           }
                        >
                           <div>
                              {commentData.map((fieldChangelog, i) => (
                                 <div className="gx-pb-1" key={fieldChangelog?.value}>
                                    <span className="gx-pr-1">
                                       <b>{`${fieldChangelog?.label}: `}</b>
                                    </span>
                                    {typeof fieldChangelog?.value === "string" &&
                                    fieldChangelog?.value?.includes("_anchor_") ? (
                                       <span
                                          className={`comment-anchor`}
                                          id={`anchor-${commentData[i]?.value.replaceAll(
                                             "_anchor_",
                                             "",
                                          )}`}
                                          onClick={() =>
                                             scrollToFieldByTechname?.(
                                                commentData[i]?.value.split("_anchor_")[1],
                                             )
                                          }
                                       >
                                          <IntlMessages id="comments.show" />
                                          {" ->"}
                                       </span>
                                    ) : (
                                       <>
                                          {fieldChangelog.label !== "New File" &&
                                          fieldChangelog.label !== "Remove File" ? (
                                             <>
                                                <span
                                                   style={{ textDecoration: "line-through" }}
                                                >{`${fieldChangelog.initial}`}</span>
                                                <span>
                                                   <b>{` -> `}</b>
                                                </span>
                                             </>
                                          ) : null}

                                          <span>{`${fieldChangelog.value}`}</span>
                                       </>
                                    )}
                                 </div>
                              ))}
                           </div>
                        </Collapse>
                     ) : (
                        <div className="gx-flex-center">
                           <span className="gx-pr-1">
                              <b>{`${commentData[0]?.label}: `}</b>
                           </span>
                           {typeof commentData[0]?.value === "string" &&
                           commentData[0]?.value?.includes("_anchor_") ? (
                              <span
                                 className={`comment-anchor`}
                                 id={`anchor-${commentData[0]?.value.replaceAll("_anchor_", "")}`}
                                 onClick={() =>
                                    scrollToFieldByTechname?.(
                                       commentData[0]?.value.split("_anchor_")[1],
                                    )
                                 }
                              >
                                 <IntlMessages id="comments.show" />
                                 {" ->"}
                              </span>
                           ) : (
                              <>
                                 {commentData[0]?.label !== "New File" &&
                                 commentData[0]?.label !== "Remove File" ? (
                                    <>
                                       <span
                                          style={{ textDecoration: "line-through" }}
                                       >{`${commentData[0]?.initial}`}</span>
                                       <span>
                                          <b>{` -> `}</b>
                                       </span>
                                    </>
                                 ) : null}
                                 <span>{`${commentData[0]?.value}`}</span>
                              </>
                           )}
                        </div>
                     )}
                  </div>
               }
            />
         ) : null}
         <Comment
            author={author ? `${author.firstName} ${author.lastName}` : ""}
            className="comment-item"
            recipient={recipient ? `${recipient.firstName} ${recipient.lastName}` : ""}
            avatar={
               avatar ? (
                  <Avatar src={avatar} alt="avatar" />
               ) : (
                  <Avatar icon={<i className="icon icon-user"></i>} />
               )
            }
            content={
               <div
                  dangerouslySetInnerHTML={{
                     __html: sanitizeHtml(
                        getCommentWithoutSystemData(
                           comment?.comment === "" ? "-" : (comment?.comment ?? "-"),
                        ),
                        {
                           allowedTags: sanitizeHtml.defaults.allowedTags.concat(["img"]),
                        },
                     ),
                  }}
                  onClick={(e) => openImage(e.target)}
                  className="comment-item-content"
               />
            }
            datetime={comment.created}
         />
         {isImageOpen && (
            <div className="fullscreen-image-overlay" onClick={closeImage}>
               <img src={imageSrc} alt="Image" />
            </div>
         )}
      </>
   );
};

export default CommentsItem;
